"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Col = _interopRequireDefault(require("react-bootstrap/Col"));
var _Button = _interopRequireDefault(require("react-bootstrap/Button"));
var _Modal = _interopRequireDefault(require("react-bootstrap/Modal"));
var _usersession = require("usersession");
var _borrowerLeadGenerationTool = require("borrower-lead-generation-tool");
require("./css/ApplyNow.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * Gunavant Jambu
 * Created Seprate Component for reuse in another project.
 *
 * LRTV-20 - updated form to use borrower-lead-generation-tool.
 * ApplyNowPost no longer required.
 * No functionality was removed for this update and the file structure is similar to before.
 * The useState hooks are used to fill out the props passed into blgt.
 * The handleCloseVM provides a constant callback that closes the modal.
 * The useEffect has 2 separate sections.
 * 1. Updates the userSession as before with the data that is passed into this component.
 * 2. Updates the useState hooks to submit all the same information to the api.
 * The final hooks are used to display a dynamic form header.
 * The page render keeps the same form elements from before as well as the same conditional
 * rendering statements. The useEffect was updated to not run if the props.leadSource is BLCHMWEB
 **/

function ApplyNow(props) {
  const [branch, setBranch] = (0, _react.useState)("");
  const [loanPurpose, setLoanPurpose] = (0, _react.useState)("");
  const [offerAmount, setOfferAmount] = (0, _react.useState)("");
  const [offerLoanProductCode, setOfferLoanProductCode] = (0, _react.useState)("");
  const [offerLoanType, setOfferLoanType] = (0, _react.useState)("");
  const [offerPI, setOfferPI] = (0, _react.useState)("");
  const [offerRate, setOfferRate] = (0, _react.useState)("");
  const [offerTerm, setOfferTerm] = (0, _react.useState)("");
  const [showApplyModal, setShowApplyModal] = (0, _react.useState)(false);

  // This function close the modal the capture the ratequote leads, clean the form and set the differents conditions to false.
  const handleApplyModalClose = () => setShowApplyModal(false);
  const userSession = new _usersession.UserSession();
  (0, _react.useEffect)(() => {
    if (props.leadSource !== "BL617RAN003") {
      if (props.data && props.data !== "") {
        userSession.getSelectedProduct().setLoanType(props.data.loanType);
        userSession.getSelectedProduct().setLoanTerm(props.data.loanTerm);
        userSession.getSelectedProduct().setProductCode(props.data.productCode);
        userSession.getSelectedProduct().setLoanAmount(props.data.loanAmount);
        userSession.getSelectedProduct().setPrice(props.data.price);
        userSession.getSelectedProduct().setRate(props.data.rate);
        userSession.getSelectedProduct().setMargin(props.data.margin);
        userSession.getSelectedProduct().setLockPeriod(props.data.lockPeriod);
        userSession.getSelectedProduct().setEstClosingCost(props.data.estClosingCost);
        userSession.getSelectedProduct().setCredit(props.data.credit);
        userSession.getSelectedProduct().setApr(props.data.apr);
        userSession.getSelectedProduct().setPI(props.data.PI);
        switch (props.data.loanType) {
          case "Conventional":
            setOfferLoanType("200");
            break;
          case "FHA":
            setOfferLoanType("111");
            break;
          case "VA":
            setOfferLoanType("120");
            break;
          case "USDA":
            setOfferLoanType("130");
            break;
          //no default
        }
        setBranch(userSession.getBranchCode());
        setLoanPurpose(userSession.getLoanPurposeCode());
        setOfferAmount(props.data.loanAmount);
        setOfferLoanProductCode(props.data.productCode);
        setOfferPI(props.data.PI);
        setOfferRate(props.data.rate);
        setOfferTerm(props.data.amortTerm / 12);
      }
    }
  }, [props.data, props.leadSource, userSession.getLoanPurposeCode()]);

  // stores current formRef
  const [node, setNode] = (0, _react.useState)(null);
  // tracks changes to formRef and stores current with setNode
  const formRef = (0, _react.useCallback)(node => {
    setNode(node);
  }, []);
  return props.data && props.data !== "" && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Modal.default, {
    size: "lg",
    show: showApplyModal,
    onHide: handleApplyModalClose,
    className: "applyNowWrapper"
  }, /*#__PURE__*/_react.default.createElement(_Modal.default.Header, null, /*#__PURE__*/_react.default.createElement(_Button.default, {
    onClick: handleApplyModalClose,
    "aria-label": "Close SWMC Apply Now Modal",
    className: "btn-close-applyNow"
  }, "\xD7")), /*#__PURE__*/_react.default.createElement(_Modal.default.Body, {
    className: "pt-0"
  }, node &&
  /*#__PURE__*/
  // dynamically renders the custom form header
  _react.default.createElement("div", {
    className: "applyNowHeader"
  }, "Please fill the information below to continue"), /*#__PURE__*/_react.default.createElement("div", {
    className: "applyNowBody"
  }, /*#__PURE__*/_react.default.createElement(_borrowerLeadGenerationTool.BorrowerLeadGenerationTool, {
    ref: formRef,
    loID: props.loanOfficerUid ? props.loanOfficerUid : undefined,
    showCustomizeLOApplyNowUrl: props.showCustomizeLOApplyNowUrl ? props.showCustomizeLOApplyNowUrl : undefined,
    loanOfficerEmail: props.loanOfficerEmail ? props.loanOfficerEmail : undefined,
    branch: branch,
    leadSource: props.leadSource,
    loanPurposeKeyword: loanPurpose,
    offerAmount: offerAmount,
    offerLoanProductCode: offerLoanProductCode,
    offerLoanType: offerLoanType,
    offerPI: offerPI,
    offerRate: offerRate,
    offerTerm: offerTerm,
    promoCode: props.promoCode ? props.promoCode : userSession.getPromoCode(),
    loanOfficerUid: props.loanOfficerUid || ""
  })))), props.leadSource === "BL617RAN003" ? /*#__PURE__*/_react.default.createElement(_Col.default, null, /*#__PURE__*/_react.default.createElement("span", {
    className: "btnApplyNow"
  }, props.children)) : /*#__PURE__*/_react.default.createElement(_Col.default, null, /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: "btnApplyNow",
    onClick: () => setShowApplyModal(true)
  }, props.children)));
}
var _default = exports.default = ApplyNow;